// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Ap1","title":"styles_title__1AAba"};